/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global jQuery, jQuery, Swiper, ScrollMagic*/

jQuery( document ).ready(function() {
    // Step 1: Create jQuery plugin
    // ============================

    jQuery.fn.fancyMorph = function( opts ) {

        var Morphing = function( jQuerybtn, opts ) {
        var self = this;

        self.opts = jQuery.extend({
            animationEffect : false,
            infobar    : false,
            buttons    : ['close'],
            smallBtn   : false,
            touch      : false,
            baseClass  : 'fancybox-morphing',
            afterClose : function() {
            self.close();
            }
        }, opts);

        self.init( jQuerybtn );
        };

        Morphing.prototype.init = function( jQuerybtn ) {
        var self = this;

        self.jQuerybtn = jQuerybtn.addClass('morphing-btn');

        self.jQueryclone = jQuery('<div class="morphing-btn-clone" />')
            .hide()
            .appendTo( jQuerybtn );

        // Add wrapping element and set initial width used for positioning
        jQuerybtn.wrap( '<span class="morphing-btn-wrap"></span>' ).on('click', function(e) {
            e.preventDefault();

            jQuery(this).addClass("color-transparent");

            jQuery('#actualites').addClass('overflow-v');

            // jQuery(this).append('<div class="loading"><div class="loader"></div></div>');
            // jQuery('.loading').insertBefore(this).hide().fadeIn(2000);

            var post_id = jQuery(this).attr('data-id');

            jQuery("#morphing-content-" + post_id).empty();

            jQuery.post(
                ajaxurl,
                {
                    'action': 'morphing_popup',
                    'id': post_id
                },
                function(response){
                    jQuery('#morphing-content-' + post_id).append(response);
                    jQuery('.loading').remove();
                    jQuery('.loader').remove();
                    jQuery('.color-transparent').removeClass('color-transparent');
                    self.start()
                }
            );
        });

        };

        Morphing.prototype.start = function() {
        var self = this;

        if ( self.jQuerybtn.hasClass('morphing-btn_circle') ) {
            return;
        }

        // Set initial width, because it is not possible to start CSS transition from "auto"
        self.jQuerybtn.width( self.jQuerybtn.width() ).parent().width( self.jQuerybtn.outerWidth() );

        self.jQuerybtn.off('.fm').on("transitionend.fm webkitTransitionEnd.fm oTransitionEnd.fm MSTransitionEnd.fm", function(e) {

            if ( e.originalEvent.propertyName === 'width' ) {
            self.jQuerybtn.off('.fm');

            self.animateBg();
            }

        }).addClass('morphing-btn_circle');

        };

        Morphing.prototype.animateBg = function() {
        var self = this;

        self.scaleBg();

        self.jQueryclone.show();

        // Trigger repaint
        self.jQueryclone[0].offsetHeight;

        self.jQueryclone.off('.fm').on("transitionend.fm webkitTransitionEnd.fm oTransitionEnd.fm MSTransitionEnd.fm", function(e) {
            self.jQueryclone.off('.fm');

            self.complete();

        }).addClass('morphing-btn-clone_visible');
        };

        Morphing.prototype.scaleBg = function() {
        var self = this;

        var jQueryclone = self.jQueryclone;
        var scale  = self.getScale();
        var jQuerybtn   = self.jQuerybtn;
        var pos    = jQuerybtn.offset();

        jQueryclone.css({
                position  : 'absolute',
                top       : - (jQuerybtn.outerHeight()  * scale) / 2 + 24,
                left      : - (jQuerybtn.outerWidth() * scale) / 2 + 22,
                width     : jQuerybtn.outerWidth()  * scale,
                height    : jQuerybtn.outerHeight() * scale,
                transform : 'scale(' + ( 1 / scale ) + ')'
            });
        };

        Morphing.prototype.getScale = function() {
        var jQuerybtn    = this.jQuerybtn,
            radius  = jQuerybtn.outerWidth() * 0.5,
            left    = jQuerybtn.offset().left + radius - jQuery(window).scrollLeft(),
            top     = jQuerybtn.offset().top  + radius - jQuery(window).scrollTop(),
            windowW = jQuery(window).width(),
            windowH = jQuery(window).height();

        var maxDistHor  = ( left > windowW / 2 ) ? left : ( windowW - left ),
            maxDistVert = ( top > windowH / 2 )  ? top  : ( windowH - top );

        return Math.ceil(Math.sqrt( Math.pow( maxDistHor, 2 ) + Math.pow( maxDistVert, 2 ) ) / radius );
        };

        Morphing.prototype.complete = function() {
        var self = this;
        var jQuerybtn = self.jQuerybtn;

        jQuery.fancybox.open({
            src : jQuerybtn.data('src') || jQuerybtn.attr('href'),
            opts : {
                afterShow : function( instance, current ) {
                    jQuery('.fancybox-container.fancybox-morphing.fancybox-is-open .card').addClass('visible');
                }
            }
        }, self.opts);

        jQuery(window).on('resize.fm', function() {
            //self.scaleBg();
        });
        };

        Morphing.prototype.close = function() {
        var self   = this;
        var jQueryclone = self.jQueryclone;

        self.scaleBg();

        jQueryclone.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
            jQueryclone.hide();

            self.jQuerybtn.removeClass('morphing-btn_circle');

            jQuery('#actualites').removeClass('overflow-v');
        });

        jQueryclone.removeClass('morphing-btn-clone_visible');

        jQuery(window).off('resize.fm');
        };

        // Init
        this.each(function() {
        var jQuerythis = jQuery(this);

        if ( !jQuerythis.data("morphing") ) {
            jQuerythis.data( "morphing", new Morphing( jQuerythis, opts ) );
        }

        });

        return this;
    };

    // Step 2: Start using it!
    // =======================

    jQuery("[data-morphing]").fancyMorph({
        hash : 'morphing'
    });

});
